import SEOTestPage from '../../components/SEOTestPage';
import { SEO_TESTS } from '../../data/seoTestsConfig';
export default function KonsantrasyonKaybiTestiPage() {
  return <SEOTestPage testConfig={SEO_TESTS['konsantrasyon-kaybi-testi']} />;
}
